<p>promotion-manager works!</p>
